import Axios from 'axios';
import header from './auth/header';

const API_URL = process.env.API_URL + '/api/v3/pengajuan-lending';

class PengajuanLending {
	index() {
		return Axios.get(API_URL + '/funder', { headers: header() });
	}

	store(data) {
		return Axios.post(API_URL + '/funder', data, { headers: header() });
	}

	getDocumentUrl(data) {
		return Axios.post(API_URL + '/funder/sign/document-url', data, { headers: header() });
	}

	getUrlWebviewAuthSign(data) {
		return Axios.post(API_URL + '/funder/sign/webview-auth-sign', data, { headers: header() });
	}

	getUrlMitraAuthSign(data) {
		return Axios.post(API_URL + `/mitra-utama/sign/mitra-auth-sign`, data, { headers: header() });
	}

	getMitraDocumentUrl(encrypted_key, data) {
		return Axios.post(API_URL + `/sign/${encrypted_key}/mitra-document-url`, data, { headers: header() });
	}

	getUrlWebviewMitraAuthSign(encrypted_key, data) {
		return Axios.post(API_URL + `/sign/${encrypted_key}/mitra-webview-auth-sign`, data, { headers: header() });
	}

	redirectAuthSign(encrypted_key, data) {
		return Axios.post(API_URL + `/sign/${encrypted_key}/redirect-auth-sign`, data, { headers: header() });
	}
}

export default new PengajuanLending();



// WEBPACK FOOTER //
// ./src/api/PengajuanLending.js